import { auth, db } from "../../../firebaseConfig"; // Make sure to import your Firebase configuration
import { doc, setDoc } from "firebase/firestore";
import { getSelectedUid } from "../../../../frontend/Recruitment/Applications/Utils/UidListener";

const arrayToIndexedObject = (rows = []) => {
  return rows.reduce((acc, row, index) => {
    acc[index] = row;
    return acc;
  }, {});
};

const writeDataS3 = async (formData) => {
  const userId = getSelectedUid(); // Get the selected UID
  if (!userId) {
    throw new Error("Invalid user.");
  }

  try {
    const docRef1 = doc(
      db,
      "Advisers",
      userId,
      "Application Details",

      "Life Assurance Companies",
    );
    const docRef2 = doc(
      db,
      "Advisers",
      userId,
      "Application Details",

      "Work History",
    );

    const lifeAssuranceCompanies = arrayToIndexedObject(
      Array.isArray(formData?.lifeAssuranceCompanies)
        ? formData.lifeAssuranceCompanies
        : [],
    );
    const workHistory = arrayToIndexedObject(
      Array.isArray(formData?.workHistory) ? formData.workHistory : [],
    );

    await Promise.all([
      // Overwrite documents so removed rows are actually deleted in Firestore.
      setDoc(docRef1, lifeAssuranceCompanies),
      setDoc(docRef2, workHistory),
    ]);

    // console.log("Section 3 data successfully written to Firestore!");
  } catch (error) {
    // console.error("Error writing Section 3 data to Firestore: ", error);
  }
};

export default writeDataS3;
